import React from 'react';
import PropTypes from 'prop-types';
import { NavLinkComponent } from './NavLink.styles';
import Icon from '../shared/Icon/Icon';

const NavLink = ({ text, active, subNav, mobile, path, onClick, ...props }) => {
  return (
    <NavLinkComponent {...props} active={active} path={path} mobile={`${true}`} link={subNav ? 'false' : 'true'} onClick={onClick}>
      {text}
      {subNav && <Icon icon={mobile ? 'chevron-right' : 'chevron-down'} />}
    </NavLinkComponent>
  );
};

NavLink.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func,
  subNav: PropTypes.bool,
  mobile: PropTypes.bool,
  active: PropTypes.string,
};

export default NavLink;